import { useCodesStore } from '~/store';

import ImageWithGuard from './ImageWithGuard';

/** @description 은행 로고 이미지를 표시하는 컴포넌트 */
const BankLogoImage = ({ bankCode, size = 22 }: { bankCode: string; size?: number }) => {
  const { getBankImageUrl } = useCodesStore((state) => state.actions);
  const bankImageUrl = getBankImageUrl(bankCode) ?? '';

  return <ImageWithGuard alt={bankCode} errorMode="hide" src={bankImageUrl} width={size} height={size} />;
};

export default BankLogoImage;
